export function reportHandsFreeActivity({
  isRecording,
  isListening,
  isSpeaking,
  updateActivity,
}: {
  isRecording: boolean;
  isListening: boolean;
  isSpeaking: boolean;
  updateActivity: () => void;
}): void {
  if (!isRecording) return;

  if (isListening) {
    updateActivity();
  }
  if (isSpeaking) {
    updateActivity();
  }
}

export function initializeIframeUrlIfUnset({
  current,
  candidate,
  set,
}: {
  current: string | null;
  candidate: string | null | undefined;
  set: (url: string | null) => void;
}): void {
  if (!current && candidate) {
    set(candidate);
  }
}

export function initializeMobileAppEmbedUrlIfUnset({
  current,
  candidate,
  set,
}: {
  current: string | null;
  candidate: string | null | undefined;
  set: (url: string | null) => void;
}): void {
  if (!current && candidate) {
    set(candidate);
  }
}

export function preloadMobileAppEmbedUrl({
  shouldPreload,
  preloadUrl,
  set,
}: {
  shouldPreload: boolean;
  preloadUrl: string | null;
  set: (url: string | null) => void;
}): void {
  if (shouldPreload && preloadUrl) {
    set(preloadUrl);
  }
}

export function stopListeningWhenConversationOver({
  isConversationOver,
  isStarted = true,
  stopListening,
}: {
  isConversationOver: boolean;
  isStarted?: boolean;
  stopListening: () => void;
}): void {
  if (isConversationOver && isStarted) {
    stopListening();
  }
}

export function requestIntroTts({
  transcript,
  messageId,
  getSpeech,
}: {
  transcript: string | null | undefined;
  messageId: string;
  getSpeech: (messageId: string, transcript: string) => void;
}): void {
  if (transcript) {
    getSpeech(messageId, transcript);
  }
}

export function scheduleHandsFreeVoiceEntry({
  shouldEnter,
  setResponseMode,
  startListening,
}: {
  shouldEnter: boolean;
  setResponseMode: (mode: 'voice' | 'text') => void;
  startListening?: () => Promise<void>;
}): (() => void) | undefined {
  if (!shouldEnter) return undefined;

  const timeoutId = setTimeout(() => {
    setResponseMode('voice');
    startListening?.().catch(() => undefined);
  }, 500);

  return () => clearTimeout(timeoutId);
}
